import { render, staticRenderFns } from "./listing.vue?vue&type=template&id=0bfd1dbc&scoped=true"
import script from "./listing.vue?vue&type=script&lang=js"
export * from "./listing.vue?vue&type=script&lang=js"
import style0 from "./listing.vue?vue&type=style&index=0&id=0bfd1dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfd1dbc",
  null
  
)

export default component.exports